var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28.5,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 25.5836C20.9993 22.0398 23.8722 19.167 27.416 19.167C30.5552 19.167 33.17 21.4223 33.7242 24.4014C33.8019 24.8192 34.1006 25.1616 34.5039 25.2954C36.8265 26.0657 38.4994 28.2558 38.4994 30.8336C38.4994 34.0553 35.8877 36.667 32.666 36.667C32.0217 36.667 31.4993 37.1893 31.4993 37.8336C31.4993 38.478 32.0217 39.0003 32.666 39.0003C37.1763 39.0003 40.8327 35.3439 40.8327 30.8336C40.8327 27.4591 38.7866 24.5651 35.87 23.3198C34.872 19.5846 31.4664 16.8336 27.416 16.8336C22.5835 16.8336 18.666 20.7511 18.666 25.5836C18.666 25.7006 18.6683 25.8171 18.6729 25.9331C16.5782 27.1416 15.166 29.4049 15.166 32.0003C15.166 35.8663 18.3 39.0003 22.166 39.0003C22.8103 39.0003 23.3327 38.478 23.3327 37.8336C23.3327 37.1893 22.8103 36.667 22.166 36.667C19.5887 36.667 17.4993 34.5776 17.4993 32.0003C17.4993 30.0667 18.6756 28.4052 20.3561 27.6972C20.8424 27.4924 21.1307 26.9866 21.0591 26.4638C21.0197 26.1766 20.9993 25.8828 20.9993 25.5836Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2243 31.1283C27.6663 30.7354 28.3324 30.7354 28.7744 31.1283L30.5244 32.6839C31.006 33.1119 31.0494 33.8494 30.6213 34.3309C30.2468 34.7522 29.6356 34.8382 29.166 34.5665V40.167C29.166 40.8113 28.6437 41.3336 27.9993 41.3336C27.355 41.3336 26.8327 40.8113 26.8327 40.167V34.5665C26.3631 34.8382 25.7519 34.7522 25.3774 34.3309C24.9493 33.8494 24.9927 33.1119 25.4743 32.6839L27.2243 31.1283Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.592adf9314d12a4e5965ba34e50ec2f0.svg";
export { ForwardRef as ReactComponent };